module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('PageHeader', {
    attrs: {
      "title": "Account",
      "subtitle": "Update your user information"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "sm-p-30 xs-pt-30 xs-pb-30 xs-pl-10 xs-pr-10"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-12 col-sm-6 col-form-label",
    attrs: {
      "for": "txtName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-6"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtName",
      "placeholder": "First name"
    },
    domProps: {
      "value": _vm._s(_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtLName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": _vm._s(_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lastName = $event.target.value
      }
    }
  })])])])])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-12 col-sm-6 col-form-label",
    attrs: {
      "for": "txtEmail"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "txtEmail"
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-12 col-sm-6 col-form-label",
    attrs: {
      "for": "txtNewPass"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "txtNewPass"
    },
    domProps: {
      "value": _vm._s(_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-12 col-sm-6 col-form-label",
    attrs: {
      "for": "txtConfirmPass"
    }
  }, [_vm._v("Confirm password")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password_confirmation),
      expression: "user.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "txtConfirmPass"
    },
    domProps: {
      "value": _vm._s(_vm.user.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password_confirmation = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-6 text-right"
  }, [_vm._c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b014e7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/account.vue
// module id = 689
// module chunks = 1